import Location from './location'
import User from './user'


// This class initializes the logic for managing property data
/**
 * @author -- Peter Collins cpnzereogu@gmail
 */

class Property {
    constructor (object) {
        this._typeof = 'property'

        if (object) {
            this._type = object.type
        }

        this._leaser = new User()
        this._location = new Location()
    }

    // getters

    get type() {
        return this._type
    }

    get typeof() {
        return this._typeof
    }


    // setters

}

export default Property
